module.exports = __webpack_public_path__ + "static/img/sj.4fbfc171.png";